"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LSBUpdateStatus = exports.LSBUpdateModel = exports.LsbUpdateClose = exports.ShowContent = exports.Show = exports.LsbUpdateRender = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var LsbUpdateRender = function () {
    var container = $('body div.dow-lsb-msg');
    if (container.length <= 0) {
        $('body').append('<div class="dow-lsb-msg"></div>');
    }
    _container = $('body div.dow-lsb-msg')[0];
};
exports.LsbUpdateRender = LsbUpdateRender;
var Show = function (lSBUpdateStatus) {
    var model = new LsbUpdateModel();
    switch (lSBUpdateStatus) {
        case LSBUpdateStatus.Updating:
            model.MSG = l.Translator.translate("lsb updating");
            l.DTM.push({
                type: "eSupportprocess_complete",
                name: "LSB: Force Update",
                action: "Button Click"
            });
            break;
        case LSBUpdateStatus.UpdateFailed:
            model.MSG = l.Translator.translate("lsb update failed");
            l.DTM.Lmd.pusherrorinfTrack('LSB Update Error', 'Force update error');
            break;
        default:
            model.MSG = '';
            break;
    }
    ReactDOM.render(React.createElement(LsbUpdate, __assign({}, model)), _container);
    $(_container).find("#divLsbUpdate").modal("show");
};
exports.Show = Show;
var ShowContent = function (content) {
    var model = new LsbUpdateModel();
    model.MSG = content;
    ReactDOM.render(React.createElement(LsbUpdate, __assign({}, model)), _container);
    $(_container).find("#divLsbUpdate").modal("show");
};
exports.ShowContent = ShowContent;
var LsbUpdateClose = function () {
    if ($(_container).find("#divLsbUpdate").is(":visible")) {
        $(_container).find("#divLsbUpdate").modal("hide");
    }
};
exports.LsbUpdateClose = LsbUpdateClose;
var LsbUpdateModel = /** @class */ (function () {
    function LsbUpdateModel() {
        this.MSG = '';
    }
    return LsbUpdateModel;
}());
var _container;
var LsbUpdate = /** @class */ (function (_super) {
    __extends(LsbUpdate, _super);
    function LsbUpdate(props) {
        return _super.call(this, props) || this;
    }
    LsbUpdate.prototype.Close = function () {
        if ($("#divLsbUpdate").is(":visible")) {
            $("#divLsbUpdate").modal("hide");
        }
    };
    LsbUpdate.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "modal fade dow-lsb-update", id: "divLsbUpdate", "data-backdrop": "static" },
                React.createElement("div", { className: "modal-dialog" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("span", null, l.Translator.translate("Lenovo Service Bridge")),
                            React.createElement("span", { type: "button", className: "close icon-l-close", onClick: this.Close, "aria-label": "Close" })),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("span", { id: "span-lenovo-alerts", className: "dow-msg-icon icon-warning" }),
                            React.createElement("span", null, this.props.MSG)),
                        React.createElement("div", { className: "modal-footer dow-modal-footer" },
                            React.createElement("a", { className: "btn btn-default", onClick: this.Close }, l.Translator.translate("OK"))))))));
    };
    return LsbUpdate;
}(React.Component));
var LSBUpdateModel = /** @class */ (function () {
    function LSBUpdateModel() {
    }
    return LSBUpdateModel;
}());
exports.LSBUpdateModel = LSBUpdateModel;
var LSBUpdateStatus;
(function (LSBUpdateStatus) {
    LSBUpdateStatus[LSBUpdateStatus["Updating"] = 0] = "Updating";
    LSBUpdateStatus[LSBUpdateStatus["UpdateFailed"] = 1] = "UpdateFailed";
})(LSBUpdateStatus = exports.LSBUpdateStatus || (exports.LSBUpdateStatus = {}));
